export enum HotelRoomStatus {
  Available = 'available',
  Unavailable = 'unavailable',
  Reason = 'reason'
}
